import classNames from 'classnames';
import { Flex } from 'antd';
import { MButton, TabButton } from '@Components/Base';

import { ViewResolver } from '@Components/ViewResolver';
// import { ReactComponent as SearchIcon } from '@Icons/additional/search-gradient.svg';
// import { ReactComponent as ImportIcon } from '@Icons/additional/download-gradient.svg';

import { ViewTab } from '../../ViewTab.enum';

import styles from './material-confirmation-tabs.module.css';

interface MaterialConfirmationActionsProps {
  setActiveTab: React.Dispatch<React.SetStateAction<keyof typeof ViewTab>>;
  isFetched?: boolean;
}

const MaterialConfirmationActions: React.FC<
  MaterialConfirmationActionsProps
> = ({ setActiveTab, isFetched = false }) => {
  return (
    <Flex gap={16}>
      <TabButton
        className={classNames(
          'trojan-neumorphism-box trojan-neumorphism-box-shadow',
          styles.confirmationTabs
        )}
      >
        <MButton
          onClick={() => setActiveTab(ViewTab.DETAILS)}
          type="text"
          disabled={isFetched}
        >
          Details
        </MButton>
        <MButton
          onClick={() => setActiveTab(ViewTab.MATERIALS)}
          type="text"
          disabled={isFetched}
        >
          Materials
        </MButton>
        <MButton
          onClick={() => setActiveTab(ViewTab.DOCUMENTS)}
          type="text"
          disabled={isFetched}
        >
          Documents
        </MButton>
      </TabButton>
      <ViewResolver
        desktop={null}
        // TODO: hide, no functionallity
        //         <>
        //   <div
        //     className={classNames(
        //       'trojan-neumorphism-box trojan-neumorphism-box-shadow',
        //       styles.actionBox
        //     )}
        //   >
        //     <ImportIcon />
        //   </div>
        //   <div
        //     className={classNames(
        //       'trojan-neumorphism-box trojan-neumorphism-box-shadow',
        //       styles.actionBox
        //     )}
        //   >
        //     <SearchIcon />
        //   </div>
        // </>
        mobile={null}
      />
    </Flex>
  );
};

export default MaterialConfirmationActions;
